import { i18n } from '@/utils/i18n';

export const columns = {
    id: {
        show: true,
        title: "№",
        sortable: true,
        column: 'id'
    },

    doctor_id: {
        show: true,
        title: i18n.t('message.doctor'),
        sortable: true,
        column: 'doctor_id'
    },
   
    percent: {
        show: true,
        title: i18n.t('message.percent_'),
        sortable: true,
        column: 'percent'
    },
    created_at: {
        show: true,
        title: i18n.t('message.date'),
        sortable: true,
        column: 'created_at'
    },
    updated_at: {
        show: false,
        title: i18n.t('message.update_date'),
        sortable: true,
        column: 'updated_at'
    },
    settings: {
        show: true,
        title: i18n.t('message.settings'),
        sortable: false,
        column: 'settings'
    }
};
